/* SECTIONS */
export const SECTION_PARALLAX_CLASSNAME = 'zf--parallax';
export const SECTION_GLASS_OVERLAY_CLASSNAME = 'zf--glass-section-overlay';
export const SECTION_GLASS_OVERLAY_DARK_CLASSNAME = 'zf--glass-section-overlay-dark';
export const SECTION_CUSTOM_OVERLAY_CLASSNAME = 'zf--section-custom-overlay';

/* TILES */
export const TILE_HOVER_RISE_CLASSNAME = 'zf--rise-hover';
export const TILE_HOVER_DROP_CLASSNAME = 'zf--drop-hover';
export const TILE_HOVER_IMAGE_ZOOM_CLASSNAME = 'zf--image-zoom';
export const TILE_HOVER_IMAGE_GREYSCALE_CLASSNAME = 'zf--black-white-color';
export const TILE_HOVER_BACKGROUND_COLOR_CLASSNAME = 'zf--hover-background-color';
export const TILE_HOVER_TEXT_COLOR_CLASSNAME = 'zf--hover-text-color';

/* CAPTIONS */
export const CAPTION_RIGHT_CLASSNAME = 'zf--right-caption';
export const CAPTION_LEFT_CLASSNAME = 'zf--left-caption';

export const TILE_HOVER_CLASSNAMES_BY_TYPE = {
  'none': '',
  'rise': TILE_HOVER_RISE_CLASSNAME,
  'drop': TILE_HOVER_DROP_CLASSNAME,
  'zoom': TILE_HOVER_IMAGE_ZOOM_CLASSNAME,
  'greyscale': TILE_HOVER_IMAGE_GREYSCALE_CLASSNAME,
};

export const ALL_CSS_WIKI_CLASSNAMES = [
  SECTION_PARALLAX_CLASSNAME,
  SECTION_GLASS_OVERLAY_CLASSNAME,
  SECTION_CUSTOM_OVERLAY_CLASSNAME,
  SECTION_GLASS_OVERLAY_DARK_CLASSNAME,

  TILE_HOVER_RISE_CLASSNAME,
  TILE_HOVER_DROP_CLASSNAME,
  TILE_HOVER_IMAGE_ZOOM_CLASSNAME,
  TILE_HOVER_IMAGE_GREYSCALE_CLASSNAME,
  TILE_HOVER_BACKGROUND_COLOR_CLASSNAME,
  TILE_HOVER_TEXT_COLOR_CLASSNAME,

  CAPTION_RIGHT_CLASSNAME,
  CAPTION_LEFT_CLASSNAME,
];
